import numeral from 'numeral';

export function formatNumber(number){
  if(isNaN(number) || number <= 0){
    return '-';
  }
  return numeral(number).format(number > 1000000 ? '0.0a' : '0a').replace('.0', '');
};



// WEBPACK FOOTER //
// ./src/utils/dyzio.js